import Image from 'next/image';
import React, { type CSSProperties } from 'react';
import { cn } from '@/lib/utils';

// I couldn't see an environment variable for the images as the CDN url was hard coded in quite a few places.
// Leaving these as variables for now until it is centralised.
const LOGO_CDN_URL = 'https://cdn.uppbeat.io/images/logo/uppbeat-logo.png';
const LOGO_SYMBOL_CDN_URL = 'https://cdn.uppbeat.io/images/logo/uppbeat-logo-symbol.png';
interface UBLogoProps {
  className?: string;
  height?: number;
  width?: number;
}
const _UBLogo = ({
  width = 137,
  height = 48,
  className
}: UBLogoProps) => <Image alt="Uppbeat Logo" className={cn('h-auto w-[var(--logo-width)] max-w-full', className)} height={height} priority src={`${LOGO_CDN_URL}?width=${width * 2}`} style={{
  '--logo-width': `${width}px`,
  '--logo-height': `${height}px`
} as CSSProperties} width={width} data-sentry-element="Image" data-sentry-component="_UBLogo" data-sentry-source-file="Logo.tsx" />;
export const UBLogo = React.memo(_UBLogo);
interface UBLogoSmallProps {
  className?: string;
  height?: number;
  width?: number;
}
const _UBLogoSmall = ({
  width = 26,
  height = 40,
  className
}: UBLogoSmallProps) => <Image alt="Uppbeat" className={cn('h-auto w-[var(--logo-width)] max-w-full', className)} height={height} priority src={`${LOGO_SYMBOL_CDN_URL}?width=${width * 2}`} style={{
  '--logo-width': `${width}px`,
  '--logo-height': `${height}px`
} as CSSProperties} width={width} data-sentry-element="Image" data-sentry-component="_UBLogoSmall" data-sentry-source-file="Logo.tsx" />;
export const UBLogoSmall = React.memo(_UBLogoSmall);
interface UBLogoMobileProps {
  className?: string;
  height?: number;
  width?: number;
}
const _UBLogoMobile = ({
  width = 24,
  height = 40,
  className
}: UBLogoMobileProps) => <Image alt="Uppbeat" className={cn('h-auto w-[var(--logo-width)] max-w-full object-contain', className)} height={height} priority src={`${LOGO_SYMBOL_CDN_URL}?width=${width * 2}`} style={{
  '--logo-width': `${width}px`,
  '--logo-height': `${height}px`
} as CSSProperties} width={width} data-sentry-element="Image" data-sentry-component="_UBLogoMobile" data-sentry-source-file="Logo.tsx" />;
export const UBLogoMobile = React.memo(_UBLogoMobile);